/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;height:100%}.react-frame[_ngcontent-%COMP%]{position:relative;width:100%;height:100%}.react-frame-body[_ngcontent-%COMP%]{display:block;width:100%;height:100%;border:0;background:#fff}.react-frame-loading[_ngcontent-%COMP%]{position:absolute;top:0;right:0;bottom:0;left:0;z-index:1;display:flex;align-items:center;justify-content:center;color:#7d83cf;background:#fff}"];
export { styles as styles };
